// Idle launchers for Ask Hopscotch.
// Desktop/tablet: a minimal 44×52 handle on the right edge ("opens into a
// right rail"). Phone: a bottom-right ink pill above the bottom nav.
// Per DEP-184: the desktop/tablet handle is coral (not paper) so it reads
// clearly against the paper page background instead of blending in.
// The coral unread dot appears ONLY when something genuinely unread arrived
// while the panel was closed — never as permanent decoration.

import { forwardRef } from 'react'
import './styles/CompanionLaunchers.css'

interface LauncherProps {
  onClick: () => void
  unread: boolean
}

export const CompanionHandle = forwardRef<HTMLButtonElement, LauncherProps>(
  function CompanionHandle({ onClick, unread }, ref) {
    return (
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        aria-label="Open Ask Hopscotch"
        className="hs-press companion-launcher companion-launcher--handle"
      >
        <span className="companion-launcher__icon-wrap">
          <svg
            width="22"
            height="22"
            viewBox="0 0 20 20"
            fill="none"
            stroke="#fff"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 5.5h12v7H9l-3.2 2.6V12.5H4z" />
          </svg>
          {unread && (
            <span className="companion-launcher__dot companion-launcher__dot--handle" />
          )}
        </span>
      </button>
    )
  },
)

export const CompanionMobileLauncher = forwardRef<HTMLButtonElement, LauncherProps>(
  function CompanionMobileLauncher({ onClick, unread }, ref) {
    return (
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        aria-label="Open Ask Hopscotch"
        className="hs-press companion-launcher companion-launcher--mobile"
      >
        <span className="companion-launcher__icon-wrap">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            stroke="#fff"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 5.5h12v7H9l-3.2 2.6V12.5H4z" />
          </svg>
          {unread && (
            <span className="companion-launcher__dot companion-launcher__dot--mobile" />
          )}
        </span>
        <span className="companion-launcher__label">Ask</span>
      </button>
    )
  },
)
